export default "__VITE_ASSET__DPoariwp__"